/* eslint-disable no-undef */
import React, { lazy, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  MainContainer,
  RecogntionTopCard
} from "../Recognition/CompanyAnalytics/styles";
import { ImageUrl } from "../../utils/constants";
import { commaSeperator, fetchApi, /*generateDummyData*/ } from "../../utils/methods";
import {
  TopChallengesWrapper,
} from "../CompanyEvents/styles";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import { Heading } from './styles'
import BarChart from '../common/Manager/BarChart';
import MonthlyBarChart from "../common/Manager/MonthlyChart/MonthlyBarChart";
import { toast } from "react-toastify";
import { GetMonthAndQuarterlyPerformance, GetQuarterlyCelebrations } from "../../redux/constants/apiConstants";
import CommonTableInfiniteScroll from "../common/CommonTable/CommonTableInfiniteScroll";
import SkeletonLoder from "../common/skeletonLoder";
// import { GetSocialFeedSnapshot } from "../../redux/constants/apiConstants";


const CompanyAnalytics = ({ companyInfo, selectedYear, topCardsAndGraph, monthlyBreakDown, topPerformingEmployee, topPerformingManager, topThree, topTotal, topThreeLocation, topTotalLocation, topCardsAndGraphLoader }) => {
  // const [showTopRecogntion, setShowTopRecogntion] = useState(false);
  // const [showEliteCelebration, setShowEliteCelebration] = useState(false);
  // const [showTopCelebration, setShowTopCelebration] = useState(false);
  // const [topCardsAndGraph, getTopCardsAndGraph] = useState([]);
  // const [monthlyBreakDown, getmonthlyBreakDown] = useState([]);
  const [monthData, setMonthData] = useState([]);
  const [quarterData, setQuarterData] = useState([]);
  const [monthName, setMonthName] = useState("");
  const [quarterName, setQuarterName] = useState("");
  const [anniversaryData, setAnniversaryData] = useState([]);
  const [birthdayData, setBirthdayData] = useState([]);
  // const [currentQuarterName, setCurrentQuarterName] = useState("");
  const currentYear = new Date().getFullYear();

  const [showAllMonth, setShowAllMonth] = useState(false);
  const [showAllQuarter, setShowAllQuarter] = useState(false);
  const [showAllAnniversary, setShowAllAnniversary] = useState(false);
  const [showAllBirthday, setShowAllBirthday] = useState(false);
  const [pageNumberReceived, setPageNumberReceived] = useState(1);
  const [pageNumberReceivedBirthday, setPageNumberReceivedBirthday] = useState(1);
  const [pageNumberReceivedMonth, setPageNumberReceivedMonth] = useState(1);
  const [pageNumberReceivedQuarter, setPageNumberReceivedQuarter] = useState(1);
  const [anniversaryResponse, setAnniversaryResponse] = useState([]);
  const [birthdayResponse, setBirthdayResponse] = useState([]);

  const [monthResponse, setMonthResponse] = useState([]);
  const [quarterResponse, setQuarterResponse] = useState([]);


  const handleShowMoreMonth = (month) => {
    setShowAllMonth((prev) => ({ ...prev, [month]: !prev[month] }));
  };
  const handleShowMoreQuarter = (month) => {
    setShowAllQuarter((prev) => ({ ...prev, [month]: !prev[month] }));
  };
  const handleShowMoreAnniversary = (month) => {
    setShowAllAnniversary((prev) => ({ ...prev, [month]: !prev[month] }));
  };
  const handleShowMoreBirthday = (month) => {
    setShowAllBirthday((prev) => ({ ...prev, [month]: !prev[month] }));
  };
  // useEffect(() => {
  //   fetchTopCardsAndGraph();
  // }, []);

  // const fetchTopCardsAndGraph = async() => {
  //   try {
  //     const res = await fetchApi(GetSocialFeedSnapshot +"/"+ companyInfo?.id +"/"+ selectedYear,"GET");
  //     if(res?.data?.message){
  //       toast.error(res.data.message)
  //     }else{
  //       getTopCardsAndGraph(res?.data?.top_4_cards)
  //       getmonthlyBreakDown(res?.data)
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   }
  // };

  useEffect(() => {
    fetchQuarterlyCelebrationsDetails(1, "anniversary", 7);
    fetchQuarterlyCelebrationsDetails(1, "birthday", 7);
    fetchPerformanceDetails(1, "month", 7);
    fetchPerformanceDetails(1, "quarter", 7);
  }, [])



  const setPageNumberPaginationReceived = (value) => {
    setPageNumberReceived(value)
    fetchQuarterlyCelebrationsDetails(value, "anniversary", 7)
  }


  const setPageNumberPaginationReceivedBirthday = (value) => {
    setPageNumberReceivedBirthday(value)
    fetchQuarterlyCelebrationsDetails(value, "birthday", 7)
  }


  const setPageNumberPaginationReceivedMonth = (value) => {
    setPageNumberReceivedMonth(value)
    fetchPerformanceDetails(value, "month", 7)
  }


  const setPageNumberPaginationReceivedQuarter = (value) => {
    setPageNumberReceivedQuarter(value)
    fetchPerformanceDetails(value, "quarter", 7)
  }



  const fetchPerformanceDetails = async (page, type, limit) => {
    let company_id = companyInfo.id

    let apiUrl = `${GetMonthAndQuarterlyPerformance}/${company_id}/${type}/${page}/${limit}`;
    // let apiUrl = `${GetDepartmentAnylytics}/1/month/2`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {

        if (type === "month") {
          setMonthResponse(res.data.current_month)
          setMonthName(res.data.current_month.month_name);
          const formattedData = res.data.current_month.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            department: member?.department || "",
            location: member?.location || "",
            total_posts: member?.recognition_count || 0,
          }));

          if (page === 1) {
            setMonthData([...formattedData]);
          } else {
            setMonthData([...monthData, ...formattedData]);
          }

        } else {
          setQuarterResponse(res.data.current_quarter)
          setQuarterName(res.data.current_quarter.quarter_name);
          const formattedData = res.data.current_quarter.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            department: member?.department || "",
            location: member?.location || "",
            total_posts: member?.recognition_count || 0,
          }));

          if (page === 1) {
            setQuarterData([...formattedData]);
          } else {
            setQuarterData([...quarterData, ...formattedData]);
          }
        }
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }



  const fetchQuarterlyCelebrationsDetails = async (page, celebration_type, limit) => {
    let company_id = companyInfo.id

    let apiUrl = `${GetQuarterlyCelebrations}/${company_id}/${celebration_type}/${page}/${limit}`;

    // let apiUrl = `${GetDepartmentAnylytics}/1/month/2`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {

        if (celebration_type === "anniversary") {
          setAnniversaryResponse(res.data)
          // setCurrentQuarterName(res.data.quarter_name);
          const formattedData = res.data.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            total_posts: member?.work_anniversary || 0,
          }));

          if (page === 1) {
            setAnniversaryData([...formattedData]);
          } else {
            setAnniversaryData([...anniversaryData, ...formattedData]);
          }

        } else {
          setBirthdayResponse(res.data)
          // setCurrentQuarterName(res.data.quarter_name)
          const formattedData = res.data.data.map((member) => ({
            name: member?.user_name || "",  // Use an empty string instead of "NA"
            image: member?.profile_image || "profile-Image/default.png",
            total_posts: member?.birthday || 0,
          }));
          if (page === 1) {
            setBirthdayData([...formattedData]);
          } else {
            setBirthdayData([...birthdayData, ...formattedData]);
          }
        }

      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }




  // const topDepartment = () => {
  //   if (!topThree?.length) return [];
  
  //   return (
  //     <TopDataGraph
  //       data={topThree}
  //       heading="Top Performing Departments"
  //       total={topTotal}
  //       totalSubText="Recognition Received"
  //     />
  //   );
  // };


  const topDepartment = () => {
    window.console.log("")
    return (
      <TopDataGraph
        data={topThree}
        heading="Top Performing Departments"
        total={topTotal}
        totalSubText="Recognition Received"
      />
    );
  };



  const topLocation = () => {
    // if (!topThreeLocation?.length) return null;
    window.console.log("")
    return (
      <TopDataGraph
        data={topThreeLocation}
        heading="Top Performing Locations"
        total={topTotalLocation}
        totalSubText="Recognition Received"
      />
    );
  
  };

  const showRecognitionDetails = () => {
    const EngagementEmployeeData = [
      {
        id: 1,
        title: "Total Social Posts",
        value: "1",
        img: "/admin-recognition/icons/SocialBox.svg",
        text: "posted",
        color: "rgba(133, 192, 234, 1)",
        total: topCardsAndGraph?.social_posts,
        imageBackground: "#DA92C8",
        subText: "Posts",
        info: "",
        average:
          topCardsAndGraph?.user_post_posted_percentage + "% " +
          (topCardsAndGraph?.user_post_posted_percentage <= 1 ? "of user posted" : "of users posted"),
      },
      {
        id: 2,
        title: "Recognition Received",
        titleNew: "",
        value: "2",
        img: "/admin-recognition/icons/TotalRecognitionimg.svg",
        text: "received recognition",
        color: "rgba(220, 148, 181, 1)",
        total: topCardsAndGraph?.received_recognition,
        average:
          topCardsAndGraph?.received_recognition_percentage +
          "% " +
          (topCardsAndGraph?.received_recognition_percentage <= 1
            ? "of user received recognition"
            : "of users received recognition"),
        imageBackground: "#91C49D",
        subText: "People Received",
        info: "",
      },
      {
        id: 3,
        title: "Recognition Given",
        value: "3",
        img: "/admin-recognition/icons/PeerRecognitionimg.svg",
        text: "gave recognition",
        color: "rgba(118, 171, 120, 1)",
        total: topCardsAndGraph?.gave_recognition,
        average:
          topCardsAndGraph?.gave_recognition_percentage +
          "% " +
          (topCardsAndGraph?.gave_recognition_percentage <= 1
            ? "of user gave recognition"
            : "of users gave recognition"),
        imageBackground: "#BE7D9C",
        subText: "People Gave",
        info: "",
      },
      {
        id: 4,
        title: "Exemplify Company Values",
        titleNew: "Value",
        value: "4",
        img: "/admin-recognition/icons/Exempifiesimg.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: topCardsAndGraph?.exemplifies,
        average:
          topCardsAndGraph?.exemplifies_percentage +
          "% " +
          (topCardsAndGraph?.exemplifies_percentage <= 1
            ? "of user rewarded for values"
            : "of users rewarded for values"),
        imageBackground: "#B1AA56",
        subText: "People Exemplified",
        info: "",
      },
    ];
    return EngagementEmployeeData.map((details, index) => (
      !topCardsAndGraphLoader ?
        <RecogntionTopCard key={index} background={details.imageBackground} id={"socialPost"+details.id}>
          <div className="image">
            <img src={ImageUrl + details.img} />
          </div>
          <div className="title">{details.title}</div>
          <div className="value">{commaSeperator(details?.total)}</div>
          <div className="percent-user">{details.average}</div>
        </RecogntionTopCard> : <SkeletonLoder key={index} width={"290px"} height={"195px"} />
    ))
  };

  // const topdepartment = [
  //   { name: 'Element 1', value: 70, image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED" },
  //   { name: 'Element 2', value: 60 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED"},
  //   { name: 'Element 3', value: 50 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#F0F7FF"},
  //   { name: 'Element 4', value: 40 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FEF2F3"},
  //   { name: 'Element 5', value: 30 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#F0F7FF"},
  //   { name: 'Element 6', value: 20 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FEF2F3"},
  //   { name: 'Element 7', value: 70, image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED" },
  // ];

  // const toggleShowEliteRecognition = (value) => {
  //   if(value=="celebration"){
  //     setShowEliteCelebration(!showEliteCelebration)
  //   }
  //   else{
  //     setShowEliteRecogntion(!showEliteRecogntion);
  //   }
  // };

  // const toggleShowTopRecognition = (value) => {
  //   if(value=="celebration"){
  //     setShowTopCelebration(!showTopCelebration)
  //   }
  //   else{
  //     setShowTopRecogntion(!showTopRecogntion)
  //   }
  // };

  const bestPerformer = () => {
    // const displayedTopDepartments = showTopRecogntion ? generateDummyData(12) : generateDummyData(12).slice(0, 5);
    window.console.log("")
    // const displayedEliteDepartments = showEliteRecogntion ? generateDummyData(12) : generateDummyData(12).slice(0, 5);
    return (
      <>

        {monthData?.length > 0 && (
          <div className='top-performing' style={{ display: "block" }}>
            <CommonTableInfiniteScroll
              title={`${monthName} | Monthly`}
              headers={["Employees", "Total"]}
              data={monthData}
              showAll={showAllMonth}
              handleShowMore={handleShowMoreMonth}
              // isPadding={true}
              imageBaseUrl={true}
              res={monthResponse}
              pageNumberReceived={pageNumberReceivedMonth}
              setPageNumberPaginationReceived={setPageNumberPaginationReceivedMonth}
            />
          </div>
        )}

        {/* <div className='top-performing' style={{display:"block"}} >
          <Table padding="8px 0" insight>
            <div className="heading">October | Monthly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total</div>
              </div>
            )}
            <ScrollableContainer
              height={showTopRecogntion ? "380px" : "330px"}
              showAllRows={showTopRecogntion}
            >
              {displayedTopDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" + data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.value}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>

        </div> */}
        {quarterData?.length > 0 && (
          <div className='low-performing' style={{ display: "block" }}>
            <CommonTableInfiniteScroll
              title={`${quarterName} | Quarterly`}
              headers={["Employees", "Total"]}
              data={quarterData}
              showAll={showAllQuarter}
              handleShowMore={handleShowMoreQuarter}
              // isPadding={true}
              imageBaseUrl={true}
              res={quarterResponse}
              pageNumberReceived={pageNumberReceivedQuarter}
              setPageNumberPaginationReceived={setPageNumberPaginationReceivedQuarter}
            />
          </div>
        )}



        {/* <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">October-December | Quarterly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total</div>
              </div>
            )}
            <ScrollableContainer
              height={showEliteRecogntion ? "380px" : "330px"}
              showAllRows={showEliteRecogntion}
            >
              {displayedEliteDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" +data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.value}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showEliteRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
           
          </Table>

        </div> */}
      </>
    )
  }

  const celebrations = () => {
    // const displayedTopDepartments = showTopCelebration ? generateDummyData(12) : generateDummyData(12).slice(0, 5);
    window.console.log("")
    // const displayedEliteDepartments = showEliteCelebration ? generateDummyData(12) : generateDummyData(12).slice(0, 5);
    return (
      <>

        {/* {anniversaryData?.length > 0 && ( */}
        <div className='top-performing' id="work-anniversary" style={{ display: "block" }}>
          <CommonTableInfiniteScroll
            title={"Work Anniversaries"}
            headers={["Employees", "Total"]}
            data={anniversaryData}
            showAll={showAllAnniversary}
            handleShowMore={handleShowMoreAnniversary}
            // isPadding={true}
            imageBaseUrl={true}
            hideHeaders={true}
            res={anniversaryResponse}
            pageNumberReceived={pageNumberReceived}
            setPageNumberPaginationReceived={setPageNumberPaginationReceived}
          />
        </div>
        {/* )} */}
        {/* <div className='top-performing' style={{display:"block"}} >
       
          <Table padding="8px 0" insight>
            <div className="heading">Work Anniversaries</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employee</div>
                <div className="value">Total</div>
              </div>
            )}
            <ScrollableContainer
              height={showTopCelebration ? "380px" : "330px"}
              showAllRows={showTopCelebration}
            >
              {displayedTopDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" + data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.date}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showTopCelebration && (
              <div className="showmore">
                <div className="button"  onClick={()=>toggleShowTopRecognition("celebration")}>
                  Show More
                </div>
              </div>
            )}
           
          </Table>
          
        </div> */}
        {/* {birthdayData?.length > 0 && ( */}
        <div className='low-performing' id="birthdays" style={{ display: "block" }}>
          <CommonTableInfiniteScroll
            title={"Birthdays"}
            headers={["Employees", "Total"]}
            data={birthdayData}
            res={birthdayResponse}
            showAll={showAllBirthday}
            handleShowMore={handleShowMoreBirthday}
            // isPadding={true}
            imageBaseUrl={true}
            hideHeaders={true}
            setPageNumberPaginationReceived={setPageNumberPaginationReceivedBirthday}
            pageNumberReceived={pageNumberReceivedBirthday}
          />
        </div>
        {/* )} */}

        {/* <div className='low-performing' style={{display:"block"}}>


          <Table padding="8px 0" insight>
            <div className="heading">Birthdays</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employee</div>
                <div className="value">Total</div>
              </div>
            )}
            <ScrollableContainer
              height={showEliteCelebration ? "380px" : "330px"}
              showAllRows={showEliteCelebration}
            >
              {displayedEliteDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" + data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.date}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showEliteCelebration && (
              <div className="showmore">
                <div className="button" onClick={()=>toggleShowEliteRecognition("celebration")}>
                  Show More
                </div>
              </div>
            )}
           
          </Table>

        </div> */}
      </>
    )
  }


  const transformUsers = (top_recognized) => (
    top_recognized?.map((user) => ({
      full_name: user.user_name,
      image: user?.profile_image,
      total_recognitions: user.recognition_count
    }))
  )
  const topManager = transformUsers(topPerformingManager?.top_recognized)
  const topEmployee = transformUsers(topPerformingEmployee?.top_recognized)
  return (


    <>
      <MainContainer margin>
        <TopChallengesWrapper margin="0 0 0px 0">
          {showRecognitionDetails()}
        </TopChallengesWrapper>
        <div className="main-top-low-card" style={{ margin: "20px 0px" }}>
          <div className='top-performing' style={{ display: "block" }} id="top-manager">
            <BarChart heading="Top Performing Managers | Overall" data={topManager?.slice(0, 5)} id={1} total={topPerformingManager?.total_top_recognized} totalText="Recognition Received" barColor={"#BDDDC2"} circleColor={"#418856"} circleBorderColor={"#91C49D"}/>
          </div>
          <div className='low-performing' style={{ display: "block" }} id="top-employees">
            <BarChart total={topPerformingEmployee?.total_top_recognized} totalText="Recognition Received" heading="Top Performing Employees | Overall" data={topEmployee?.slice(0, 5)} id={2} barColor={"#D3DEF2"} circleColor={"#8391D1"} circleBorderColor={"#B9C8E8"} />
          </div>
        </div>
        <div className="main-top-low-card">
          <div className='top-performing'>{topDepartment()}</div>
          <div className='top-performing'>{topLocation()}</div>
        </div>
        {selectedYear == currentYear ? (<div>
          {monthData?.length > 0 ? <Heading>
            <div className='icon'>
              <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
            </div>
            Best Performers
          </Heading>:null}
          <div className="main-top-low-card" style={{ marginTop: "20px" }}>
            {bestPerformer()}
          </div>
        </div>) : null}
        {selectedYear == currentYear ? <div>
          {anniversaryData?.length > 0  || birthdayData?.length > 0 ? <Heading>
            <div className='icon'>
              <img src={ImageUrl + "/admin-recognition/celebration.svg"} />
            </div>
            Quarterly Celebrations
          </Heading>:null}
          <div className="main-top-low-card" style={{ marginTop: "20px" }}>
            {celebrations("celebration")}
          </div>
        </div> : null}
      </MainContainer>
      <div style={{ marginTop: "20px" }} id="monthly-brakedown"><MonthlyBarChart totalText="Recognition Received"
        total={monthlyBreakDown?.total_posts} totalPercentage={monthlyBreakDown?.monthly_growth > 0 ? monthlyBreakDown?.monthly_growth : 0 } heading="Monthly Breakdown" dataGraph={monthlyBreakDown?.monthly_breakdown} /></div>
    </>
  );
};

CompanyAnalytics.propTypes = {
  selectedYearInfo: PropTypes.number,
  selectedYear: PropTypes.string,
  companyInfo: PropTypes.object.isRequired,
  monthlyBreakDown: PropTypes.array,
  topCardsAndGraph: PropTypes.array,
  topPerformingEmployee: PropTypes.object,
  topPerformingManager: PropTypes.object,
  topThree: PropTypes.object,
  topThreeLocation: PropTypes.object,
  topTotal: PropTypes.number,
  topTotalLocation: PropTypes.number,
  topCardsAndGraphLoader: PropTypes.bool
};

const mapStateToProps = (state) => ({
  selectedYearInfo: state.companyDashboard.selectedYearInfo
});

export default connect(mapStateToProps, null)(CompanyAnalytics);